export const selectDetails = store => store?.data?.details;
export const selectEpisodes = store => store?.data?.episodes;
export const selectEpisodeDetails = store => store?.data?.episodeDetails;
